<template>
  <v-card color="transparent">
    <v-footer>
      <v-container>
        <v-row>
          <v-col
            v-for="(column,c) in links"
            :key="`col-${c}`"
            :cols="12"
            :md="cols_md"
            class="pl-0"
          >
            <v-subheader>
              <h4>{{column.header}}</h4>
            </v-subheader>
            <v-list color="transparent" nav dense>
              <v-list-item
                v-for="(link,l) in column.links"
                :key="`link-${l}`"
                :to="link.to"
                color="grey"
              >
                <v-list-item-content>
                  <v-list-item-title class="grey--text">{{ trans(link.title, null, link.fallback) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <v-divider></v-divider>
    <v-container>
      <v-row class="px-3">
        <v-col cols="6">
          <small class="grey--text text--lighten-1">{{ trans('app.copyright_info', null, `Copyright © 2021. Localrent.`) }}</small>
        </v-col>
        <v-col cols="6" class="d-flex justify-end align-center">
          <div class="grey--text subtitle-2 mr-2">Follow Us</div>
          <v-btn icon class="ml-1">
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
          <v-btn icon class="ml-1">
            <v-icon>mdi-twitter</v-icon>
          </v-btn>
          <v-btn icon class="ml-1">
            <v-icon>mdi-linkedin</v-icon>
          </v-btn>
          <v-btn icon class="ml-1">
            <v-icon>mdi-youtube</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import _ from "lodash";
export default {
  data: () => ({
    links: [
      // column 1
      {
        header: "Local Rent",
        links: [
          {
            title: "app.footer_link_1",
            fallback: "Terms & Conditions",
            to: {
              name: "article",
              params: {
                alias: "terms-and-conditions"
              }
            }
          },
          {
            title: "app.footer_link_2",
            fallback: "Data security",
            to: {
              name: "article",
              params: {
                alias: "data-security"
              }
            }
          },
          {
            title: "app.footer_link_3",
            fallback: "Cookie policy",
            to: {
              name: "article",
              params: {
                alias: "cookie-policy"
              }
            }
          }
        ]
      },

      {
        header: "Tenants",
        links: [
          {
            title: "app.footer_link_4",
            fallback: "How To Rent",
            to: {
              name: "renting"
            }
          },
          {
            title: "app.footer_link_5",
            fallback: "Pricing",
            to: {
              name: "home"
            }
          }
        ]
      },
      {
        header: "Landlords",
        links: [
          {
            title: "app.footer_link_6",
            fallback: "How To Rent",
            to: {
              name: "renting-out"
            }
          },
          {
            title: "app.footer_link_7",
            fallback: "Pricing",
            to: {
              name: "home"
            }
          },
          {
            title: "app.footer_link_8",
            fallback: "Localrent API",
            to: {
              name: "home"
            }
          }
        ]
      },
      {
        header: "Support",
        links: [
          {
            title: "app.footer_link_9",
            fallback: "FAQ",
            to: {
              name: "faq"
            }
          },
          {
            title: "app.footer_link_10",
            fallback: "Contact Us",
            to: {
              name: "contact"
            }
          }
        ]
      }
    ]
  }),

  computed: {
    cols_md: function() {
      // return 12 / _.size(this.links);
      return 2;
    }
  }
};
</script>
